import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import SeApplication from './SeApplication'
import SeFileView from './SeFileView'
import SeReturn from './SeReturn'

const Se = () => {
  const { path } = useRouteMatch()

  const [selectedSection, setSelectedSection] = useState('se')

  const actionListModule = useSelector(
    getUserModuleActions('compensation-approval', 'loan', 'se')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'compensation-approval',
      'loan',
      'se',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="se">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('se')
                    }}
                    eventKey="se"
                  >
                    SE Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('se-return')
                    }}
                    eventKey="se-return"
                  >
                    SE Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'se' ? (
              <>
                {checkPermission('view', actionListModule) && <SeApplication />}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <SeReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <SeFileView type="view" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <SeFileView type="file-return" {...props} />}
      />
    </Switch>
  )
}

export default Se
